<template>
  <div class="csv-exporter">
    <button @click="downloadCSV">Download CSV</button>
  </div>
</template>

<script>
export default {
  props: {
    jsonData: {
      type: Array,
      required: true,
    },
  },
  methods: {
    convertToCSV(data) {
      if (!data || !data.length) return '';

      // Get the headers from the keys of the first object
      const headers = Object.keys(data[0]);
      const csvRows = [];

      // Add header row
      csvRows.push(headers.join(','));

      // Add data rows
      for (const row of data) {
        const values = headers.map(header => {
          const value = row[header];
          // Escape double quotes by doubling them, then wrap value in quotes
          return `"${String(value || '').replace(/"/g, '""')}"`;
        });
        csvRows.push(values.join(','));
      }

      return csvRows.join('\n');
    },

    downloadCSV() {
      const csvData = this.convertToCSV(this.jsonData);
      const blob = new Blob([csvData], { type: 'text/csv' });
      const url = URL.createObjectURL(blob);

      const link = document.createElement('a');
      link.href = url;
      link.download = 'data.csv';
      link.click();

      URL.revokeObjectURL(url);
    },
  },
};
</script>

<style scoped>
.csv-exporter {
  margin: 10px;
}
button {
  padding: 8px 16px;
  font-size: 16px;
  color: #fff;
  background-color: #10294c;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}
button:hover {
  background-color: #0d2142;
}
</style>
